import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import {
  CloseBtn,
  Divider,
  ModalBackdrop,
  ModalContainer,
  ModalHeader,
  ModalHeaderTitles,
  ModalSubtitle,
  ModalTitle,
} from './ModalTransaction.styled';
import { AddTransaction } from 'components/Modal/ModalTransaction/AddTransactionForm/AddTransaction';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const modalRoot = document.querySelector('#modal-root');

export const ModalTransactions = ({ onClose, transactionToEdit }) => {
  const indentation = '254px';
  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  });

  const handleKeyDown = evt => {
    if (evt.code === 'Escape') {
      onClose();
    }
  };

  const handleBackdropClick = evt => {
    if (evt.target === evt.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <ModalBackdrop onClick={handleBackdropClick}>
      <ModalContainer>
        <ModalHeader>
          <ModalHeaderTitles>
            <ModalTitle>
              {transactionToEdit
                ? t('modalTitles.editTransaction')
                : t('modalTitles.newTransaction')}
            </ModalTitle>
            <ModalSubtitle>{t('modalTitles.manageData')}</ModalSubtitle>
          </ModalHeaderTitles>
          <CloseBtn onClick={onClose} type="button" aria-label={t('madalGeneral.close')}>
            <X size={18} color="#FF7601" />
          </CloseBtn>
        </ModalHeader>
        <Divider />
        <AddTransaction
          indentation={indentation}
          onClose={onClose}
          transactionToEdit={transactionToEdit}
        />
      </ModalContainer>
    </ModalBackdrop>,
    modalRoot
  );
};
